import { Send, Share2 } from "lucide-react";
import { openWhatsAppShare } from "@/utils/share/openWhatsAppShare";

interface WhatsAppShareSectionProps {
  message: string;
  title?: string;
  description?: string;
  className?: string;
}

/** Reusable “Tell your friends” block — opens the share sheet with a pre-filled message. */
export function WhatsAppShareSection({
  message,
  title = "Tell your friends",
  description = "Share with friends. Pre-filled message ready.",
  className = "",
}: WhatsAppShareSectionProps) {
  return (
    <section
      className={`rounded-2xl border border-border/70 bg-card p-5 shadow-sm ${className}`}
    >
      <p className="flex items-center gap-2 text-sm font-semibold text-foreground">
        <Share2 className="h-4 w-4 text-emerald-600" />
        {title}
      </p>
      <p className="mt-1 text-xs text-muted-foreground">{description}</p>
      <button
        type="button"
        onClick={() => openWhatsAppShare(message)}
        className="mt-4 flex h-11 w-full items-center justify-center gap-1.5 rounded-xl bg-emerald-600 text-sm font-semibold text-white transition-colors hover:bg-emerald-700"
      >
        <Send className="h-4 w-4" />
        Share
      </button>
    </section>
  );
}
